import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  AuthorizationRequirement,
  User,
  UserRole,
} from '../models';
import { AuthService } from './auth.service';
import {
  hasPermission,
  hasRole,
  matchesAuthorizationRequirement,
} from '../utils/authorization.util';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  private authService = inject(AuthService);

  matchesCurrentUser(requirement?: AuthorizationRequirement): Observable<boolean> {
    return this.authService.ensureCurrentUser().pipe(
      map((user) => this.matches(requirement, user)),
    );
  }

  matches(
    requirement?: AuthorizationRequirement,
    user: User | null | undefined = this.authService.getCurrentUserValue(),
    organizationId = this.getCurrentOrganizationId(user),
  ): boolean {
    return matchesAuthorizationRequirement(user, requirement, organizationId);
  }

  hasRole(
    role: UserRole,
    user: User | null | undefined = this.authService.getCurrentUserValue(),
  ): boolean {
    return hasRole(user, role);
  }

  hasPermission(
    permission: string,
    user: User | null | undefined = this.authService.getCurrentUserValue(),
    organizationId = this.getCurrentOrganizationId(user),
  ): boolean {
    return hasPermission(user, permission, organizationId);
  }

  getCurrentOrganizationId(user: User | null | undefined = this.authService.getCurrentUserValue()): string | null {
    return user?.currentOrganization?.id ?? user?.organization?.id ?? null;
  }
}
